"use strict";

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HlsPlayer = void 0;

var react_1 = __importDefault(require("react"));

var HlsVideo_1 = require("./HlsVideo");

var Player_1 = require("./Player");

var PlayerFooter_1 = require("./PlayerFooter");

var QualitySelector_1 = require("./controls/QualitySelector");

function HlsPlayer(_a) {
  var _b;

  var hlsUrl = _a.hlsUrl,
      playerProps = _a.playerProps,
      props = __rest(_a, ["hlsUrl", "playerProps"]);

  var playerRef = react_1.default.useRef();

  var _react_1$default$useS = react_1.default.useState([]),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      levels = _react_1$default$useS2[0],
      setLevels = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1.default.useState(undefined),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      currentLevelIndex = _react_1$default$useS4[0],
      setCurrentLevelIndex = _react_1$default$useS4[1];

  var qualitySelector = react_1.default.createElement(QualitySelector_1.QualitySelector, {
    levels: levels,
    currentLevel: currentLevelIndex,
    onChange: setCurrentLevelIndex
  });
  return react_1.default.createElement(Player_1.Player, Object.assign({}, playerProps, {
    playerRef: playerRef,
    footerProps: Object.assign(Object.assign({}, playerProps === null || playerProps === void 0 ? void 0 : playerProps.footerProps), {
      controls: ((_b = playerProps === null || playerProps === void 0 ? void 0 : playerProps.footerProps) === null || _b === void 0 ? void 0 : _b.controls) ? [].concat(_toConsumableArray(playerProps.footerProps.controls), [qualitySelector, PlayerFooter_1.FooterControl.Fullscreen]) : [PlayerFooter_1.FooterControl.SkipBackward, PlayerFooter_1.FooterControl.SkipForward, PlayerFooter_1.FooterControl.PlaybackSpeed, PlayerFooter_1.FooterControl.Volume, qualitySelector, PlayerFooter_1.FooterControl.Fullscreen]
    })
  }), react_1.default.createElement(HlsVideo_1.HlsVideo, Object.assign({
    src: hlsUrl,
    width: '100%',
    height: '100%',
    playsInline: true,
    onLevels: setLevels,
    onCurrentLevelChange: setCurrentLevelIndex,
    currentLevel: currentLevelIndex
  }, props)));
}

exports.HlsPlayer = HlsPlayer;